module.exports = __webpack_public_path__ + "img/smart6.0b79e7cd.svg";